import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { createPulseTemplate, queryPulseTemplates } from './generated/PulseTemplateClient/pulseTemplateHttpRequests';
import { PulseTemplateClientBase } from './PulseTemplateClientBase';
export class PulseTemplateClient extends HttpBaseClient(PulseTemplateClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createPulseTemplateImpl", createPulseTemplate);
    _defineProperty(this, "queryPulseTemplatesImpl", queryPulseTemplates);
  }
}
//# sourceMappingURL=PulseTemplateClientHttp.js.map